import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";

import { withRequest } from "../../utils/request";
import Loader from "../general/Loader";
import { formatCurrency, getLink } from "../../utils/helpers";
import { auth } from "../../utils/auth";
import { apiUrl } from "../../utils/apiUrl";
import Modal from "../general/Modal";
import PrintForm from "./PrintForm";

class View extends Component {
    state = {
        nomina: { pagos: [] },
        nominas: [],
        loading: true,
        showImprimir: false,
        showCerrarNomina: false,
    };
    componentDidMount() {
        this.getNomina();
    }
    getNomina = async (url = null) => {
        const id = this.props.match.params.id;
        url = url ? url : "nominas/" + id;
        const nomina = await this.props.request(url);

        if (nomina.success) {
            this.setState({
                nomina: nomina.data[0],
                loading: false,
            });
        }
    };

    getNominas = async (sucursal) => {
        const nominas = await this.props.request(
            `nominas?sucursal=${sucursal}`
        );

        if (nominas.data && nominas.data.length) {
            return nominas.data;
        }

        return [];
    };

    toggleDropdown = (show = 0) => {
        this.setState({
            showDropdown: show === 0 ? !this.state.showDropdown : show,
        });
    };
    removeNomina = async (event) => {
        event.preventDefault();

        const id = this.props.match.params.id;
        const token = auth.getToken();

        const url = `nominas/${id}`;

        const res = await fetch(apiUrl(url), {
            method: "delete",
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token,
            },
        });

        const response = await res.json();

        if (response.success) {
            this.props.history.push(getLink("/nomina"));
            return;
        } else {
            this.setState({ errors: response.data.message });
        }
    };
    cerrarNomina = async () => {
        const id = this.props.match.params.id;
        const token = auth.getToken();

        const url = `nominas/${id}/cerrar`;

        const res = await fetch(apiUrl(url), {
            method: "post",
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token,
            },
        });

        const response = await res.json();

        if (response.success) {
            this.props.history.push(getLink("/nomina"));
            return;
        } else {
            this.setState({ errors: response.data.message });
        }
    };
    toggleImprimir = () => {
        this.setState({
            showImprimir: !this.state.showImprimir,
        });
    };
    toggleCerrarNomina = () => {
        this.setState({
            showCerrarNomina: !this.state.showCerrarNomina,
        });
    };
    render() {
        const { nomina, loading } = this.state;
        const produccion = nomina.tipo === "PROD";
        return (
            <div>
                {loading && <Loader />}
                {!loading && (
                    <div className='page-header'>
                        <h1 className='page-title row'>
                            <span class='col'>
                                {nomina.nombre}{" "}
                                {nomina.cerrada && (
                                    <small class='badge badge-success'>
                                        <i className='zmdi zmdi-lock'></i>{" "}
                                        CERRADA
                                    </small>
                                )}
                            </span>
                            <div className='dropdown m-r-10'>
                                <button className='au-btn au-btn-icon au-btn-filter'>
                                    <i className='zmdi zmdi-print'></i> Imprimir
                                </button>
                                <div
                                    style={{ right: "0", left: "auto" }}
                                    className='dropdown-menu'>
                                    <button
                                        type='button'
                                        onClick={this.toggleImprimir}
                                        className='dropdown-item'>
                                        Nómina Combinada
                                    </button>
                                    <div className='dropdown-divider'></div>
                                    <Link
                                        to={getLink(
                                            `/imprimir/nomina/${nomina.id}/resumen`
                                        )}
                                        target='_blank'
                                        className='dropdown-item'>
                                        Resumen de Nómina
                                    </Link>
                                    <Link
                                        to={getLink(
                                            `/imprimir/nomina/${nomina.id}/comprobantes-estandard`
                                        )}
                                        target='_blank'
                                        className='dropdown-item'>
                                        Volantes Estándard
                                    </Link>
                                    <Link
                                        to={getLink(
                                            `/imprimir/nomina/${nomina.id}/comprobantes`
                                        )}
                                        target='_blank'
                                        className='dropdown-item'>
                                        Volantes Producción
                                    </Link>
                                </div>
                            </div>
                            {!nomina.cerrada && (
                                <button
                                    onClick={this.toggleCerrarNomina}
                                    className='au-btn au-btn-icon au-btn--green au-btn--small'>
                                    <i className='zmdi zmdi-lock'></i> Cerrar
                                </button>
                            )}
                        </h1>
                    </div>
                )}
                <div className='row'>
                    <div className='col-md-12'>
                        <div>
                            {!nomina.pagos.length ? (
                                <div>
                                    {!loading && (
                                        <div>
                                            No pagos disponibles para esta
                                            nómina.
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className='table-data'>
                                    <div
                                        className='row'
                                        style={{
                                            borderBottom: "1px solid #e2e2e2",
                                            marginBottom: "10px",
                                            paddingBottom: "5px",
                                        }}>
                                        <div className='col'>
                                            EMPLEADOS: {nomina.empleados}
                                        </div>
                                        <div className='col text-right'>
                                            TOTAL:{" "}
                                            {formatCurrency(nomina.total)}
                                        </div>
                                    </div>
                                    <table className='table table-data2'>
                                        <thead>
                                            <tr>
                                                <th>Código</th>
                                                <th>Nombre</th>
                                                <th>Cargo</th>
                                                {produccion && (
                                                    <th className='text-right'>
                                                        Toneladas
                                                    </th>
                                                )}
                                                {produccion && (
                                                    <th className='text-right'>
                                                        Sueldo Fijo
                                                    </th>
                                                )}
                                                <th className='text-right'>
                                                    Sueldo Bruto
                                                </th>
                                                <th className='text-right'>
                                                    Descuentos
                                                </th>
                                                <th className='text-right'>
                                                    Total
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {nomina.pagos.map((pago) => (
                                                <tr
                                                    className='tr-shadow'
                                                    key={pago.codigo}>
                                                    <td>{pago.codigo}</td>
                                                    <td>{pago.nombre}</td>
                                                    <td>{pago.cargo}</td>
                                                    {produccion && (
                                                        <td className='text-right'>
                                                            {pago.toneladas}
                                                        </td>
                                                    )}
                                                    {produccion && (
                                                        <td className='text-right'>
                                                            {formatCurrency(
                                                                pago.sueldoFijo
                                                            )}
                                                        </td>
                                                    )}
                                                    <td className='text-right'>
                                                        {formatCurrency(
                                                            pago.sueldoBruto
                                                        )}
                                                    </td>
                                                    <td className='text-right'>
                                                        {formatCurrency(
                                                            pago.totalDescuentos
                                                        )}
                                                    </td>
                                                    <td className='text-right'>
                                                        {formatCurrency(
                                                            pago.total
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {!nomina.cerrada && (
                                        <div className='delete-footer'>
                                            <form onSubmit={this.removeNomina}>
                                                <button
                                                    type='submit'
                                                    className='btn'>
                                                    <i className='fas fa-trash'></i>
                                                </button>
                                            </form>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <Modal
                    blank
                    toggle={this.toggleImprimir}
                    show={this.state.showImprimir}>
                    <PrintForm
                        toggle={this.toggleImprimir}
                        getNominas={this.getNominas}
                    />
                </Modal>
                <Modal
                    toggle={this.toggleCerrarNomina}
                    title='Cerrar Nómina'
                    acceptText='Cerrar'
                    callback={this.cerrarNomina}
                    show={this.state.showCerrarNomina}>
                    Luego de cerrada la nómina no puede ser borrada. ¿Estás
                    seguro que deseas cerrarla?
                </Modal>
            </div>
        );
    }
}

export default withRouter(withRequest(View));
